import React, { useState, useContext } from 'react'
import { People, Work } from '@material-ui/icons'
import Modal from 'react-modal'
import SharePropertyList from '../HeadBar/ListOptions/SharePropertyList/SharePropertyList'
import AddListToDeal from '../HeadBar/ListOptions/AddListToDeal/AddListToDeal'
import listContext from '../../Common/context/context'

const ListAddedToDeals = () => {

    let { propertyList, setPropertyListId } = useContext(listContext)
    const [anchorEl, setAnchorEl] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = React.useState('')
    const [disableClose, setdisableClose] = useState(false)

    const customStyles = {
        content: {
            top: '30%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -40%)',
            padding: '0px !important'
        },
        overlay: { zIndex: 1050 }
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const componentToLoad = {
        SharePropertyList: <SharePropertyList closeModal={closeModal} setdisableClose={setdisableClose}></SharePropertyList>,
        AddListToDeal: <AddListToDeal closeModal={closeModal} setdisableClose={setdisableClose}></AddListToDeal>
    }

    function openModal(inpuVal) {
        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    function closeModal() {
        if (!disableClose) {
            setIsOpen(false)
        }
    }

    return (
        <>
            <div className="flex flex-row text-2 space-x-4">
                <button data-testid="test-shared-list"
                    className="btn btn-sm border-1 border-base bg-gray-15 text-primary rounded"
                    onClick={() => { openModal('SharePropertyList') }}>
                    <span className="flex">
                        <People className="pr-3" fontSize="small" />
                        Shared with ({propertyList && propertyList.sharedWithUsers.length})
                    </span>
                </button>
                <button data-testid="test-addDeals-list"
                    className="btn btn-sm border-1 border-base bg-gray-15 text-primary rounded"
                    onClick={() => { openModal('AddListToDeal') }}>
                    <span className="flex">
                        <Work className="pr-3" fontSize="small" />
                        Add to deal ({propertyList && propertyList.sharedDeals.length})
                    </span>
                </button>
            </div>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                {componentToLoad[selectedOption]}
            </Modal>
        </>
    )
}


export default ListAddedToDeals
